import axiosInstance from '../../helpers/axiosInstance'

export default function getCampoOfSystem (sistema,campo) {
    return axiosInstance.get('camposselect/getCampos/'+sistema+'/'+campo)
        .then(response => response.data)
        .catch(error => {
          throw error;
        });
}
